import Swiper from 'swiper'
import { Navigation, Autoplay, A11y } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'

let config

export const initSwiper = () => {
  const sliders = document.querySelectorAll('[data-swiper]')

  if (!sliders.length) return

  sliders.forEach((slider) => {
    const type = slider.getAttribute('data-swiper')

    switch (type) {
      case 'gallery':
        config = {
          loop: true,
          speed: 750,
          spaceBetween: 16,
          slidesPerView: 1.2,
          initialSlide: 1,
          breakpoints: {
            650: {
              slidesPerView: 2
            }
          }
        }
        break
      case 'images':
        config = {
          loop: true,
          speed: 750,
          initialSlide: 1,
          spaceBetween: 16,
          slidesPerView: 1.5,
          breakpoints: {
            650: {
              slidesPerView: 3
            }
          }
        }
        break
      case 'destinations':
        config = {
          modules: [A11y],
          spaceBetween: 16,
          slidesPerView: 1.1,
          enabled: true,
          breakpoints: {
            651: {
              slidesPerView: 2
            },
            1025: {
              enabled: false
            }
          }
        }
        break
      default:
        break
    }

    const swiper = new Swiper(slider, { ...config })
  })
}

export default () => {}
